<template>
    <el-form :model="form">
      <el-input v-model="form.title" placeholder="제목" />
      <QuillEditor v-model:content="form.content" contentType="html"  theme="snow" toolbar="full"  style="height: 300px"/>
      <el-date-picker
        v-model="form.dates"
        type="datetimerange"
        range-separator="~"
        start-placeholder="시작"
        end-placeholder="종료"
      />
      <el-button type="primary" @click="submit">저장</el-button>
    </el-form>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import axiosInstance from "@/api/axios"; // Axios 인스턴스 가져오기
  import { ElMessage } from 'element-plus'
  import { useRouter } from 'vue-router'


  const router = useRouter()
  const form = ref({ title: '', content: '', dates: [] })
  
  const submit = async () => {
  try {
    await axiosInstance.post('/notices/', {
      title: form.value.title,
      content: form.value.content,
      start_date: form.value.dates[0],
      end_date: form.value.dates[1]
    })

    ElMessage.success('공지사항이 저장되었습니다.')
    
    router.push('/notices/manage') // ✅ 관리화면으로이동
  } catch (error) {
    console.error(error)
    ElMessage.error('저장에 실패했습니다.')
  }
}


  </script>